const baseRoute = 'dynamic-form/:moduleBridgeHex/';
export default {
  user_module_dynamicForm_base: {
    path: baseRoute,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_dynamicForm_home: {
    path: `${baseRoute}home/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_dynamicForm_add: {
    path: `${baseRoute}add/`,
    parameters: {
      moduleBridgeHex: undefined,
    },
  },
  user_module_dynamicForm_continue: {
    path: `${baseRoute}continue/`,
    parameters: {
      moduleBridgeHex: undefined,
      dynamicFormUserFormID: undefined,
    },
  },
  user_module_dynamicForm_step: {
    path: `${baseRoute}step/:dynamicFormUserFormPageID/`,
    parameters: {
      moduleBridgeHex: undefined,
      dynamicFormUserFormPageID: undefined,
    },
  },
  user_module_dynamicForm_back: {
    path: `${baseRoute}back/:dynamicFormUserFormID/`,
    parameters: {
      moduleBridgeHex: undefined,
      dynamicFormUserFormID: undefined,
    },
  },
  user_module_dynamicForm_end: {
    path: `${baseRoute}result/:dynamicFormUserFormID/`,
    parameters: {
      moduleBridgeHex: undefined,
      dynamicFormUserFormID: undefined,
    },
  },
  user_module_dynamicForm_endConfirm: {
    path: `${baseRoute}end-confirm/:dynamicFormUserFormPageID/`,
    parameters: {
      moduleBridgeHex: undefined,
      dynamicFormUserFormPageID: undefined,
    },
  },
};
